import React from "react";
import { Navigation } from "./Navigation";

export const NavigationContext = React.createContext<Navigation>(null);

type Props = {
  children?: React.ReactNode;
  navigation: Navigation;
};

export function NavigationProvider(props: Props) {
  return (
    <NavigationContext.Provider value={props.navigation}>
      {props.children}
    </NavigationContext.Provider>
  );
}

export function useNavigation(): Navigation {
  const navigation = React.useContext(NavigationContext);

  if (!navigation) {
    throw new Error(
      "Missing Navigation context. Wrap components with NavigationProvider"
    );
  }

  return navigation;
}

/**
 * @deprecated remove me when transition to the new nav. system is fully done
 */
export function useLegacyNavigation(): Navigation {
  return React.useContext(NavigationContext);
}

export type WithNavigationProps = {
  children: (navigation: Navigation) => React.ReactElement<any>;
};

export function WithNavigation(props: WithNavigationProps) {
  const navigation = useNavigation();
  return props.children(navigation);
}
